import { useI18n } from 'next-localization';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';

type Props = {
  isFetching: boolean;
  className: string;
  clearFilters: () => void;
  filterApply: () => void;
};

const MobileBaseFiltersActions = ({ isFetching, clearFilters, filterApply, className }: Props) => {
  const { t } = useI18n();
  return (
    <div className={`d-flex align-items-center justify-content-between ${className}`}>
      <AbrdnButton
        buttonType="secondary"
        className={`${isFetching ? 'disabled' : ''}`}
        onClick={clearFilters}
      >
        <span>{t('clear')}</span>
      </AbrdnButton>
      <AbrdnButton
        buttonType="primary"
        className={`${isFetching ? 'disabled' : ''}`}
        onClick={filterApply}
      >
        <span>{t('apply')}</span>
      </AbrdnButton>
    </div>
  );
};

export default MobileBaseFiltersActions;
